import { useEffect, useRef } from "react";

export default function useTokenizationForm(iframeRef: any, successCallback: any, failureCallBack: Function) {
    const handleMessageRef = useRef<(event: any) => void>(() => { });

    useEffect(() => {
        handleMessageRef.current = async (event: any) => {
            if (event.data.type === 'set_height') {
                iframeRef.current.style.height = event.data.height + "px"
            } else if (event.data.type === 'tokenization_success') {
                console.log('event: ', event)
                const { paymentInstrumentId } = event.data;
                console.log('paymentInstrumentId: ', paymentInstrumentId)
                await successCallback(paymentInstrumentId)
            } else if (event.data.type === 'tokenization_failure') {
                console.error('tokenization_failure: ', event.data)
                failureCallBack(event.data.message)
            }
        };
    }, [successCallback]);

    useEffect(() => {
        const stableMessageHandler = (event: any) => {
            handleMessageRef.current(event);
        };
        window.addEventListener('message', stableMessageHandler);
        return () => {
            window.removeEventListener('message', stableMessageHandler);
        };
    }, []);

    function submitForm() {
        if (iframeRef.current) {
            const iframeWindow = iframeRef.current.contentWindow;
            iframeWindow.postMessage({ type: 'submit_form' }, "*");
            console.log('message submitted to iframe')
        }
    }

    function clearForm() {
        if (iframeRef.current) {
            const iframeWindow = iframeRef.current.contentWindow;
            iframeWindow.postMessage({ type: 'clear_form' }, "*");
        }
    }

    return { submitForm, clearForm }
}